module.exports = __webpack_public_path__ + "5e95171cd4d0c20739b539a8a3547c98.png";